export const STEPS = [
  {
    name: "เลือกเเผน",
    value: 1
  },
  {
    name: "กรอกข้อมูล",
    value: 2
  },
  {
    name: "ชำระเงิน",
    value: 3
  }
];

export const BANKS = [
  {
    label: "โปรดเลือก",
    value: "000"
  },
  {
    label: "ธนาคารกรุงเทพ",
    value: "002"
  },
  {
    label: "ธนาคารกรุงศรีอยุธยา",
    value: "025"
  },
  {
    label: "ธนาคารกสิกรไทย",
    value: "004"
  },
  {
    label: "ธนาคารเกียรตินาคิน",
    value: "069"
  },
  {
    label: "ธนาคารซีไอเอ็มบีไทย",
    value: "022"
  },
  {
    label: "ธนาคารทหารไทย",
    value: "011"
  },
  {
    label: "ธนาคารทิสโก้",
    value: "067"
  },
  {
    label: "ธนาคารไทยพาณิชย์",
    value: "014"
  },
  {
    label: "ธนาคารเครดิตเพื่อรายย่อย",
    value: "071"
  },
  {
    label: "ธนาคารธนชาต",
    value: "065"
  },
  {
    label: "ธนาคารยูโอบี",
    value: "024"
  },
  {
    label: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
    value: "073"
  },
  {
    label: "ธนาคารแสตนดาร์ดชาร์เตอร์ด (ไทย)",
    value: "020"
  },
  {
    label: "ธนาคารกรุงไทย",
    value: "006"
  },
  {
    label: "ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย",
    value: "098"
  },
  {
    label: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
    value: "034"
  },
  {
    label: "ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย",
    value: "035"
  },
  {
    label: "ธนาคารออมสิน",
    value: "030"
  },
  {
    label: "ธนาคารอาคารสงเคราะห์",
    value: "033"
  },
  {
    label: "ธนาคารอิสลามแห่งประเทศไทย",
    value: "066"
  },
  {
    label: "ธนาคารไอซีบีซี (ไทย)",
    value: "070"
  }
  // {
  //   label: "อื่นๆ",
  //   value: "99"
  // },
];

export const BENEFITS = [
  {
    label: "บุคคลธรรมดา",
    value: "บุคคลธรรมดา"
  },
  {
    label: "นิติบุคคล",
    value: "นิติบุคคล"
  },
  {
    label: "สถาบันการเงิน",
    value: "สถาบันการเงิน"
  }
];
